import { initializeApp, firestore } from "firebase";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBJXqdebidI4cPzdxjc3bBbOYkijjx5kc0",
  authDomain: "tugende-links.firebaseapp.com",
  databaseURL: "https://tugende-links.firebaseio.com",
  projectId: "tugende-links",
  storageBucket: "tugende-links.appspot.com",
  messagingSenderId: "963122612671"
};

initializeApp(firebaseConfig);

export const db = firestore();

export const timestampToDate = timestamp => {
  return timestamp instanceof firestore.Timestamp
    ? timestamp.toDate()
    : timestamp;
};
